import {BljStoreLocatorSettings} from "../types/BljStoreLocatorSettings";
import {createSlice, PayloadAction} from "@reduxjs/toolkit";

const storeLocatorSettingsSliceInitialState: BljStoreLocatorSettings = {
    googleMapsSettings: {
        apiKey: "",
        initialZoomLevel: 4,
        googleMapsMapID: ""
    },
    mapPlaceholderCaptionText: "",
    productTypesFieldGroupCaption: "",
    productTypeTerms: []
};

const storeLocatorSettingsSlice = createSlice({

    name: 'storeLocatorSettingsSlice',
    initialState: storeLocatorSettingsSliceInitialState,
    reducers: {
        setStoreLocatorSettings(state, action: PayloadAction<BljStoreLocatorSettings>) {
            // Mutate the state directly
            Object.assign(state, action.payload);
        }
    }

});

export const storeLocatorSettingsSliceActions = storeLocatorSettingsSlice.actions;
export default storeLocatorSettingsSlice;